import ProductDescription from './ProductDescription'

const DryBeansProduct = {
  ...ProductDescription,
  category: '06',
  subCategory: '002',
  IsBroadband: true,
  BeanPeaLentilType: '',
  BeanPeaLentilSize: '16 ounces only',
}

export default DryBeansProduct
